import { cloneDeep } from 'lodash'
import { v4 as uuid } from 'uuid'
import { PackageData } from '@/utils/types'
import { ManualPackageDataPayload } from '@/pages/report/package/versions/types'
import { formatPackageDataRequest } from '@/pages/report/package/versions/v2/formatPackageData'

const buildManualPackageData = (
  payload: ManualPackageDataPayload
): PackageData => {
  const schemaBody = cloneDeep(payload.schemaBody)
  const personIdFull = payload.schemaPersonFull.person_full[0].person_id_full
  const liabilityId = uuid()
  const loanId = uuid()

  delete schemaBody.contract

  delete schemaBody.collateral

  schemaBody.loan[0].person_id_full = personIdFull
  schemaBody.loan[0].loan_id = loanId
  delete schemaBody.loan[0].collateral_alloc
  delete schemaBody.loan[0].tranche

  schemaBody.liability[0].liability_id = liabilityId
  schemaBody.liability[0].loan_id = [loanId]
  schemaBody.liability[0].person_id_full = personIdFull
  delete schemaBody.liability[0].collateral_alloc
  delete schemaBody.liability[0].tranche

  return formatPackageDataRequest({
    ...schemaBody,
    ...payload.schemaPersonFull,
  })
}

export { buildManualPackageData }
